export default "__VITE_ASSET__D60cHy67__"